import { Directive } from '@angular/core';

@Directive({ selector: '[appTableColumnLabelTemplate]' })
export class TableColumnLabelTemplateDirective { }
